import get from 'lodash/get';
import { host } from '../shared/config';

const seoPage = (data, state) => {
  const seoImageUrl =
    get(data, "data.attributes.Product.data.attributes.Image.data.attributes.url") ||
    get(data, "data.attributes.OwnerProduct.data.attributes.Image.data.attributes.url") ||
    get(data, "data.attributes.Content[0].Media.data.attributes.url") ||
    get(state.website, "Header.Logo.data.attributes.url");

  const seo = {
    Title: get(data, 'data.attributes.SEO.Title'),
    Description: get(data, 'data.attributes.SEO.Description'),
    Type: 'website',
    Publisher: get(state.website, 'Brand'),
    Brand: get(state.website, 'Brand'),
    TwitterCard: 'summary_large_image',
    TwitterSite: get(state.website, 'TwitterSite'),
    TwitterCreator: get(state.website, 'TwitterSite'),
    Image: `${host}${seoImageUrl}`,
  };
  return seo;
};

const seoEvent = (data, state) => {
  const seoImageUrl = get(data, 'data.attributes.Media.data.attributes.url') || get(state.website, 'Header.Logo.data.attributes.url');
  const seo = {
    Title: get(data, 'data.attributes.Title'),
    Description: get(data, 'data.attributes.Description'),
    Type: 'website',
    Publisher: get(state.website, 'Brand'),
    Brand: get(state.website, 'Brand'),
    TwitterCard: 'summary_large_image',
    TwitterSite: get(state.website, 'TwitterSite'),
    TwitterCreator: get(state.website, 'TwitterSite'),
    Image: `${host}${seoImageUrl}`,
  };
  return seo;
};

const seoArticle = (data, state) => {

  const seoImageUrl = (get(data, 'data.attributes.Media.data.attributes.url') || get(state.website, 'Header.Logo.data.attributes.url'));

  const seo = {
    Title: get(data, 'data.attributes.Title'),
    Description: get(data, 'data.attributes.Description'),
    Type: 'article',
    Publisher: get(state.website, 'Brand'),
    Brand: get(state.website, 'Brand'),
    TwitterCard: 'summary_large_image',
    TwitterSite: get(state.website, 'TwitterSite'),
    TwitterCreator: get(state.website, 'TwitterSite'),
    Image: `${host}${seoImageUrl}`,
  };
  return seo;
};


export { seoPage, seoArticle, seoEvent };
